import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Check = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M35.6743 7.26152C36.0821 7.63391 36.1109 8.26642 35.7385 8.67428L14.7385 31.6743C14.5543 31.876 14.2957 31.9935 14.0227 31.9997C13.7497 32.0059 13.486 31.9002 13.2929 31.7071L4.29289 22.7071C3.90237 22.3166 3.90237 21.6834 4.29289 21.2929C4.68342 20.9024 5.31658 20.9024 5.70711 21.2929L13.9671 29.5529L34.2615 7.32574C34.6339 6.91788 35.2664 6.88913 35.6743 7.26152Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Check;
